import { useTranslation } from 'react-i18next';
import { Store } from 'lucide-react';

export function SellingInformationCard({
  sellingOrganizationName,
}: {
  sellingOrganizationName: string;
}) {
  const { t } = useTranslation('order');

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <Store size={20} className="text-prim-500" />
        <h2 className="text-neutral-900 font-semibold">
          {t('order.seller_information')}
        </h2>
      </div>
      <div className="space-y-3">
        <div>
          <p className="text-xs text-gray-500 mb-1">Supplier</p>
          <p className="text-sm text-neutral-900 font-medium">
            {sellingOrganizationName}
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-500 mb-1">{t('order.location')}</p>
        </div>
      </div>
    </div>
  );
}
